import { Droppable, Draggable } from "react-beautiful-dnd";
import { Col, Form, ListGroup, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ReactComponent as EditIcon } from "assets/svg/edit.svg";
import styles from "./styles/style.module.scss";

export default function FormData({ formData, updateFormData }) {
    console.log(formData);
    return (
        <div className={styles["form-data-droppable"]}>
            <Droppable
                droppableId="form_droppable"
                type="controls"
                isDropDisabled={"false"}
                isCombineEnabled={"false"}
                ignoreContainerClipping
            >
                {(provided) => (
                    <div className="display-view">
                        <ListGroup
                            style={{
                                backgroundColor: "#9f9f9f26",
                                borderStyle: "dotted",
                                minHeight: "200px",
                                overflow: "auto",
                            }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {Object.values(formData).map((data, index) => {
                                console.log(data);
                                return (
                                    <Draggable
                                        key={`form_draggable_${index}`}
                                        draggableId={`form_draggable_${index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <ListGroup
                                                className="field"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                            >
                                                <div
                                                    className="mb-5"
                                                    {...provided.dragHandleProps}
                                                >
                                                    <FieldDetails
                                                        index={index}
                                                        control={data}
                                                        updateFormData={
                                                            updateFormData
                                                        }
                                                        formData={formData}
                                                    />
                                                </div>
                                            </ListGroup>
                                        )}
                                    </Draggable>
                                );
                            })}

                            {provided.placeholder}
                        </ListGroup>
                    </div>
                )}
            </Droppable>
        </div>
    );
}

const FieldDetails = ({ control, updateFormData, formData, index }) => {
    const handleChange = (value, fieldName) => {
        let changedData = formData;
        changedData[index][fieldName] = value;
        updateFormData(changedData);
    };

    let defaultValueLabel = "defaultValue",
        element = (
            <input
                className="form-control"
                type={control?.type}
                name={control?.label}
                value={control?.defaultValue}
                onChange={({ target: { value } }) =>
                    handleChange(value, "defaultValue")
                }
            />
        ),
        requiredSwitch = true,
        defaultValueSwitch = true,
        fieldNameSwitch = true,
        placeholderSwitch = true;

    switch (control?.primitive) {
        case true:
            switch (control?.type) {
                case "password":
                    defaultValueSwitch = false;
                    break;
                case "time":
                case "date":
                    placeholderSwitch = false;
                    break;
                case "checkbox":
                case "radio":
                    placeholderSwitch = false;
                    defaultValueLabel = "defaultChecked";
                    element = (
                        <select
                            className="form-control"
                            value={control?.defaultChecked}
                            onChange={({ target: { value } }) =>
                                handleChange(value, "defaultChecked")
                            }
                        >
                            <option value="unchecked">unchecked</option>
                            <option value="checked">checked</option>
                        </select>
                    );
                    break;
                case "image":
                    element = (
                        <Form.Control
                            type="text"
                            name={control?.label}
                            value={control?.defaultValue}
                            onChange={({ target: { value } }) =>
                                handleChange(value, "defaultValue")
                            }
                        />
                    );
                    break;
                case "file":
                    defaultValueSwitch = false;
                    break;
                default:
                    break;
            }
            break;
        case false:
            switch (control?.type) {
                case "dropdown":
                    defaultValueLabel = "defaultSelected";
                    element = (
                        <Form.Select
                            value={control?.defaultSelected}
                            onChange={({ target: { value } }) =>
                                handleChange(value, "defaultSelected")
                            }
                        >
                            <option value="none">none</option>
                            <option value="first-option">first option</option>
                        </Form.Select>
                    );
                    break;
            }
            break;
        case undefined:
            switch (control?.type) {
                case "description":
                    defaultValueLabel = "description";
                    break;
                case "title":
                    if (control?.type !== "description")
                        defaultValueLabel = "title";
                    requiredSwitch = false;
                    // labelTextSwitch = false;
                    fieldNameSwitch = false;
                    placeholderSwitch = false;
                    break;
            }
            break;
        default:
            break;
    }

    return (
        <div className="d-flex flex-wrap">
            <Col xs="12" className="d-flex justify-content-between title-row">
                <label className="title">
                    {control?.type !== "title" &&
                    control?.type !== "description" ? (
                        <>
                            <EditIcon fill="#000" />
                            <input
                                className="form-control title-input"
                                type="text"
                                value={control?.label}
                                onChange={({ target: { value } }) =>
                                    handleChange(value, "label")
                                }
                            />
                        </>
                    ) : (
                        control?.label
                    )}
                </label>
                <div className="d-flex gap-2">
                    {requiredSwitch && (
                        <label>
                            <span className="text-warning">
                                <FormattedMessage id="required" /> :{" "}
                                <input
                                    className="form-control"
                                    type="checkbox"
                                    checked={control?.required || false}
                                    onChange={({ target: { checked } }) =>
                                        handleChange(checked, "required")
                                    }
                                />
                            </span>
                        </label>
                    )}

                    <span
                        className="remove"
                        onClick={() => {
                            let spliced = formData;
                            spliced.splice(index, 1);
                            updateFormData(spliced);
                        }}
                    >
                        x
                    </span>
                </div>
            </Col>
            <div className="d-flex flex-wrap inputs-wrapper">
                {defaultValueSwitch && (
                    <Col xs="12" md="6">
                        <div className="d-flex flex-wrap">
                            <Col xs="4">
                                <label>
                                    <FormattedMessage id={defaultValueLabel} />
                                </label>
                            </Col>
                            <Col xs="8">{element}</Col>
                        </div>
                    </Col>
                )}
                {control?.type === "title" && (
                    <Col xs="12" md="6">
                        <div className="d-flex flex-wrap">
                            <Col xs="4">
                                <label>
                                    <FormattedMessage id="tag" />
                                </label>
                            </Col>
                            <Col xs="8">
                                <select
                                    className="form-control"
                                    value={control?.tag}
                                    onChange={({ target: { value } }) =>
                                        handleChange(value, "tag")
                                    }
                                >
                                    <option value="h1">h1</option>
                                    <option value="h2">h2</option>
                                    <option value="h3">h3</option>
                                    <option value="h4">h4</option>
                                    <option value="h5">h5</option>
                                    <option value="h6">h6</option>
                                </select>
                            </Col>
                        </div>
                    </Col>
                )}
                {control?.type === "file" && (
                    <Col xs="12" md="6">
                        <div className="d-flex flex-wrap">
                            <Col xs="4">
                                <label>
                                    <FormattedMessage id="accept" />
                                </label>
                            </Col>
                            <Col xs="8">
                                <input
                                    list="file-accept"
                                    className="form-control"
                                    type="text"
                                    placeholder={
                                        control?.accept || "e.g: images/*"
                                    }
                                    value={control?.accept}
                                    onChange={({ target: { value } }) =>
                                        handleChange(value, "accept")
                                    }
                                />
                                <datalist
                                    id="file-accept"
                                    value={control?.tag}
                                    onChange={({ target: { value } }) =>
                                        handleChange(value, "tag")
                                    }
                                >
                                    <option>image/*</option>
                                    <option>video/*</option>
                                    <option>audio/*</option>
                                    <option>.csv</option>
                                    <option>.pdf</option>
                                </datalist>
                            </Col>
                        </div>
                    </Col>
                )}

                {fieldNameSwitch && (
                    <Col xs="12" md="6">
                        <div className="d-flex flex-wrap">
                            <Col xs="4">
                                <label>
                                    <FormattedMessage id="fieldName" />
                                </label>
                            </Col>
                            <Col xs="8">
                                <Form.Control
                                    type="text"
                                    name="fieldName"
                                    placeholder={control?.type}
                                    value={control?.fieldName}
                                    onChange={({ target: { value } }) =>
                                        handleChange(value, "fieldName")
                                    }
                                />
                            </Col>
                        </div>
                    </Col>
                )}

                {placeholderSwitch && (
                    <Col xs="12" md="6">
                        <Row>
                            <Col xs="4">
                                <label>
                                    <FormattedMessage id="placeholder" />
                                </label>
                            </Col>
                            <Col xs="8">
                                <Form.Control
                                    type="text"
                                    name="placeholder"
                                    placeholder={control?.type}
                                    value={control?.placeholder}
                                    onChange={({ target: { value } }) =>
                                        handleChange(value, "placeholder")
                                    }
                                />
                            </Col>
                        </Row>
                    </Col>
                )}

                {control?.type === "textarea" && (
                    <>
                        <Col xs="12" md="6">
                            <Row>
                                <Col xs="4">
                                    <label>
                                        <FormattedMessage id="col" />
                                    </label>
                                </Col>
                                <Col xs="8">
                                    <Form.Control
                                        type="number"
                                        placeholder="number of col"
                                        value={control?.col}
                                        onChange={({ target: { value } }) =>
                                            handleChange(value, "col")
                                        }
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs="12" md="6">
                            <Row>
                                <Col xs="4">
                                    <label>
                                        <FormattedMessage id="rows" />
                                    </label>
                                </Col>
                                <Col xs="8">
                                    <Form.Control
                                        type="number"
                                        placeholder="number of rows"
                                        value={control?.rows}
                                        onChange={({ target: { value } }) =>
                                            handleChange(value, "rows")
                                        }
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </>
                )}
            </div>
        </div>
    );
};
